import { SignupAuthMethod } from "@components/signup/signup-auth-method";
import { SignupBackButton } from "@components/signup/signup-back-button";
import { TrialProps } from "@pages/trial/trial-types";
import { useState } from "react";
import { Box } from "@mui-wrapper";
import { PageSubtitle } from "@components/common/page-subtitle";
import { AuthMethod } from "@custom-types/signup-types";

type Props = Pick<TrialProps, "setFormData" | "setStep" | "email" | "server">;

/**
 * Renders the second step of the trial registration flow.
 * it displays the available authentication methods for the user to select.
 */
export function TrialStepTwo({
  email,
  server,
  setFormData,
  setStep,
}: Props): JSX.Element {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  /** Sets the selected authentication method and proceeds to the next step */
  function setAuthMethod(authMethod: AuthMethod): void {
    setFormData((prev) => ({
      ...prev,
      authMethod,
    }));

    setStep("three");
  }

  return (
    <Box data-testid="trial-step-two">
      <PageSubtitle
        sx={{
          marginBottom: "16px",
        }}
      >
        Choose how you want to sign up
      </PageSubtitle>
      <SignupAuthMethod
        email={email}
        server={server}
        setAuthMethod={setAuthMethod}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
      />
      <SignupBackButton
        handleBack={() => setStep("one")}
        isLoading={isLoading}
      />
    </Box>
  );
}
